import React, { useState } from 'react'
import {
  PlanFeaturesButtonsSection,
  PlanFeaturesButtonsSeparator,
  PlanFeaturesButtonsStyled,
  PlanFeaturesButtonsSectionText,
  PlanFeaturesButtonsSectionWrapper,
  PlanFeatureText,
} from 'Features/pricing/components/PlanFeaturesTable/PlanFeaturesButtons/PlanFeaturesButtons.styled'
import { Button } from '@clickcease/cc-client-components-lib'
import { useTranslation } from 'react-i18next'
import { PLAN_TYPES, PlanTypes } from 'Types/PlansTypes'
import { ScheduleCallModal } from 'Features/ScheduleCallModal/ScheduleCallModal'

type PlanFeaturesButtonsProps = {
  selectPlan(type: PlanTypes, billingCycleMonths: number): void
  exceededMaxVisits: boolean
  reactivation?: boolean
  billingCycleMonths?: number
}

export const PlanFeaturesButtons = ({
  selectPlan,
  exceededMaxVisits,
  reactivation,
  billingCycleMonths,
}: PlanFeaturesButtonsProps) => {
  const { t } = useTranslation('pricing')
  const [modalToShow, setModalToShow] = useState<boolean>(false)

  const buttonClicked = (type: PlanTypes) => {
    if (exceededMaxVisits || type === PLAN_TYPES.ENTERPRISE) {
      setModalToShow(true)
    } else {
      selectPlan(type, billingCycleMonths || 12)
    }
  }

  const buttonText = () => {
    if (reactivation) {
      return t('reactivate')
    } else if (exceededMaxVisits) {
      return t('paid_marketing.lets_talk')
    } else {
      return t('start_free_trial')
    }
  }

  return (
    <>
      <PlanFeaturesButtonsStyled>
        <PlanFeatureText>{t('features')}</PlanFeatureText>
        <PlanFeaturesButtonsSectionWrapper>
          <PlanFeaturesButtonsSection>
            <PlanFeaturesButtonsSectionText>
              {t('paid_marketing.core')}
            </PlanFeaturesButtonsSectionText>
            <Button
              onClick={() => {
                buttonClicked(PLAN_TYPES.CORE)
              }}
              text={buttonText()}
            />
          </PlanFeaturesButtonsSection>
          <PlanFeaturesButtonsSeparator />
          <PlanFeaturesButtonsSection>
            <PlanFeaturesButtonsSectionText>
              {t('paid_marketing.advanced')}
            </PlanFeaturesButtonsSectionText>
            <Button
              onClick={() => {
                buttonClicked(PLAN_TYPES.ADVANCED)
              }}
              text={buttonText()}
            />
          </PlanFeaturesButtonsSection>

          <PlanFeaturesButtonsSeparator />
          <PlanFeaturesButtonsSection>
            <PlanFeaturesButtonsSectionText>{t('enterprise')}</PlanFeaturesButtonsSectionText>
            <Button
              onClick={() => {
                buttonClicked(PLAN_TYPES.ENTERPRISE)
              }}
              text={t('paid_marketing.lets_talk')}
            />
          </PlanFeaturesButtonsSection>
        </PlanFeaturesButtonsSectionWrapper>
      </PlanFeaturesButtonsStyled>
      <ScheduleCallModal onOpenChange={() => setModalToShow(false)} isOpen={modalToShow} />
    </>
  )
}
